export default "__VITE_ASSET__b1cfe96f__"